import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs'
import workerSrc from 'pdfjs-dist/build/pdf.worker.mjs?url'

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc

const documentCache = new Map()

export async function loadPdfJsDocument(id, bytes) {
  if (documentCache.has(id)) return documentCache.get(id)
  const loadingTask = pdfjsLib.getDocument({ data: bytes.slice(0) })
  const pdf = await loadingTask.promise
  documentCache.set(id, pdf)
  return pdf
}

export function disposePdfJsDocument(id) {
  const pdf = documentCache.get(id)
  if (pdf) {
    try {
      pdf.destroy()
    } catch (_) {
      // ignore
    }
    documentCache.delete(id)
  }
}

export async function renderPageToDataURL(
  id,
  bytes,
  pageNumber,
  { scale = 1, maxWidth = 360 } = {}
) {
  const pdf = await loadPdfJsDocument(id, bytes)
  const page = await pdf.getPage(pageNumber)
  const baseViewport = page.getViewport({ scale: 1 })

  let renderScale = scale
  if (maxWidth && baseViewport.width * renderScale > maxWidth) {
    renderScale = maxWidth / baseViewport.width
  }

  const viewport = page.getViewport({ scale: renderScale })
  const canvas = document.createElement('canvas')
  canvas.width = Math.ceil(viewport.width)
  canvas.height = Math.ceil(viewport.height)
  const context = canvas.getContext('2d')

  await page.render({ canvasContext: context, viewport }).promise

  const dataUrl = canvas.toDataURL('image/jpeg', 0.8)
  return {
    dataUrl,
    width: baseViewport.width,
    height: baseViewport.height,
  }
}

export async function getPageDimensions(id, bytes, pageNumber) {
  const pdf = await loadPdfJsDocument(id, bytes)
  const page = await pdf.getPage(pageNumber)
  const viewport = page.getViewport({ scale: 1 })
  return { width: viewport.width, height: viewport.height }
}
